import { useParams } from "react-router-dom";
import { projects } from "../data";

function ProjectDetails() {
  const { projectId } = useParams(); // Get project ID from the URL
  const project = projects.find((p) => p.id === projectId); // Find matching project

  if (!project) {
    return <h2 className="text-white text-center">Project not found.</h2>;
  }

  return (
    <div className="container mx-auto p-4">
      <h2 className="text-3xl font-bold text-white">{project.title}</h2>
      <h3 className="text-green-400 text-lg">{project.subtitle}</h3>
      <img src={project.image} alt={project.title} className="w-full h-64 object-cover my-4" />
      <p className="text-gray-300">{project.description}</p>
      <a
        href={project.link}
        target="_blank"
        rel="noopener noreferrer"
        className="text-blue-400 hover:underline mt-4 block"
      >
        View Project
      </a>
    </div>
  );
}

export default ProjectDetails;